<template>
  <list-view class="combination-component-type-selector">
    <div class="combination-type"
      v-for="combinationType in combinationTypes"
      v-bind:selected="combinationType == value"
      v-on:click="combinationTypeSelected(combinationType)">
      {{ getComponentCombinationName(combinationType) }}
    </div>
  </list-view>
</template>

<script>
import listView from 'components/list-view';
import l10n from 'services/l10n-service';

export default {
  name: 'combination-component-type-selector',
  props: [
    'combinationTypes', // possible values are 'seat', 'center_chair_leg'
    'value'
  ],
  data() {
    return {};
  },
  components: {
    listView
  },
  methods: {
    combinationTypeSelected(combinationType) {
      this.$emit('combination-type-selected', combinationType);
    },
    getComponentCombinationName(combinationType) {
      return l10n.get(combinationType);
    }
  }
};
</script>

<style scoped>
.combination-component-type-selector {
  padding: 10px 15px 20px 15px;
}

.combination-type {
  padding: 5px 10px;
  color: black;
  border: 1px solid black;
  margin: 0 5px;
  cursor: pointer;
}

.combination-type[selected]:hover,
.combination-type[selected] {
  color: white;
  background: #6DADAD;
  border: 1px solid #6DADAD;
  font-weight: bold;
}

.combination-type:hover {
  background: #F0F0F0;
}
</style>


// WEBPACK FOOTER //
// combination-component-type-selector.vue?48596340